import { useColorMode } from '@vueuse/core'
import { computed } from 'vue'

export type ThemeMode = 'auto' | 'light' | 'dark'

const colorMode = useColorMode({
  selector: 'html',
  attribute: 'class',
  modes: {
    auto: '',
    light: '',
    dark: 'dark',
  },
  storageKey: 'spatius-admin-theme',
  initialValue: 'auto',
  emitAuto: false,
})

export function useTheme() {
  // `colorMode.value` resolves 'auto' to the actual system preference on read
  // when emitAuto is false, so binding the radio to it would never let the
  // user see 'auto' as the selected option. Use the underlying store ref so
  // the stored preference (which can be 'auto') round-trips faithfully.
  const mode = computed<ThemeMode>({
    get: () => colorMode.store.value as ThemeMode,
    set: (value) => {
      colorMode.store.value = value
    },
  })

  // For isDark we want the *resolved* mode, so read from colorMode itself.
  const isDark = computed(() => colorMode.value === 'dark')

  return { mode, isDark }
}
